export enum AutomationRequestName {
  createAutomation = 'createAutomation',
}

export type AutomationRequestNameType = keyof typeof AutomationRequestName;
